import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_API_URL;

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    auth: false,
    inventory: []
  },

  mutations: {
    SET_USER(state, user) {
      state.user = user;
      state.auth = Boolean(user);
    },

    SET_INVENTORY(state, data) {
      state.inventory = data;
    }
  },

  actions: {
    async register({ dispatch }, form) {
      await axios.get("/sanctum/csrf-cookie");
      await axios.post("/register", form);
      return dispatch("getUser");
    },

    async change({ dispatch }, credentials) {
      await axios.get("/sanctum/csrf-cookie");
      await axios.patch("/api/update", credentials);
      return dispatch("getUser");
    },

    async login({ dispatch }, credentials) {
      await axios.get("/sanctum/csrf-cookie");
      await axios.post("/login", credentials);
      return dispatch("getUser");
    },

    async logout({ dispatch }) {
      await axios.post("/logout");
      return dispatch("getUser");
    },

    getUser({ commit }) {
      axios
        .get("api/user")
        .then(res => {
          localStorage.setItem("userRole", res.data.roles[0].name);
          commit("SET_USER", res.data);
        })
        .catch(() => {
          localStorage.removeItem("userRole");
          commit("SET_USER", null);
        });
    },

    getInventory({ commit }) {
      axios.get("api/getActHouses").then(res => {
        commit("SET_INVENTORY", res.data);
      });
    }
  },

  getters: {
    userLogin: state => state.user,
    userAuth: state => state.auth,
    userRole: state => state.user.roles[0].name,
    inventories: state => state.inventory
  }
});
